module.exports = __webpack_public_path__ + "img/Support-skill-219.4c973b95.png";